import Slide, { SlideProps } from '@mui/material/Slide';

type TransitionProps = Omit<SlideProps, 'direction'>;

const TransitionDown = (props: TransitionProps) => {
  return <Slide {...props} direction='down' />;
};

export default TransitionDown;
